
import Vue from 'vue'
import { MAX_SLIDER_IMAGE_COUNT } from '@/product/const'
import ActiveImage from '@/product/components/ActiveImage.vue'
import ButtonShare from '@/common/components/ButtonShare.vue'
import Button3DModel from '@/common/components/Button3DModel.vue'
import { EVENT_LABELS } from '@/common/utils'
import { SVG_PLACEHOLDER_IMAGES } from '@/common/constants'
import BaseImage from '@/common/components/BaseImage.vue'
import { SkuImage } from '@/model/printableSku'
import { IMAGE_VARIANT } from '@/common/const'

export default Vue.extend({
  components: {
    ActiveImage,
    ButtonShare,
    Button3DModel,
    BaseImage
  },
  data(): {
    imageDescription: string,
    selectedImageView: SkuImage | null,
    currentImageListIndex: number,
    eventLabel: string
    }{
    return {
      imageDescription: '',
      selectedImageView: null,
      currentImageListIndex: 0,
      eventLabel: EVENT_LABELS.SHARE_IN_IMAGE
    }
  },
  computed: {
    imageLoadingItem() {
      return this.$store.getters.imageLoading
    },
    skuImageViewItem() {
      return this.$store.getters.skuImageView
    },
    productItem() {
      return this.$store.getters.product
    },
    skuImagesItems(): Array<SkuImage> {
      return this.$store.getters.skuImages
    },
    isOverMaxImageCount(): boolean {
      return this.skuImagesItems?.length > this.maxSliderImageCount
    },
    isMobileWidth() {
      return window.innerWidth < 768
    },
    maxSliderImageCount(): number {
      return this.isMobileWidth ? MAX_SLIDER_IMAGE_COUNT.MOBILE_WIDTH : MAX_SLIDER_IMAGE_COUNT.DESKTOP_WIDTH
    },
    splittedSkuImages(): Array<SkuImage[]> {
      const splittedSkuImages = []
      if (!this.isOverMaxImageCount) {
        splittedSkuImages.push(this.skuImagesItems)
        return splittedSkuImages
      }

      for (let i = 0; i < this.skuImagesItems.length; i += this.maxSliderImageCount) {
        let splittedList = this.skuImagesItems.slice(i, i + this.maxSliderImageCount)
        splittedSkuImages.push(splittedList)
      }

      return splittedSkuImages
    },
    currentImageView(): SkuImage {
      const imageView = this.selectedImageView ? this.selectedImageView : this.skuImageViewItem
      this.$store.commit('setCurrentSKUImageView', imageView)
      return imageView
    },
    isFirstImageList() {
      return this.currentImageListIndex === 0
    },
    isLastImageList(): boolean {
      return this.currentImageListIndex === this.splittedSkuImages.length - 1
    },
    placeholder(): string {
      return SVG_PLACEHOLDER_IMAGES.SQUARE
    },
    isProduct3D(): boolean {
      return !!(this.skuImageViewItem && this.productItem.sku_three_d_model !== null)
    },
    THUMBNAIL_IMG_VARIANT() {
      return IMAGE_VARIANT.SKU_THUMBNAIL
    },
    ACTIVE_IMG_VARIANT() {
      return IMAGE_VARIANT.SKU_MAIN
    },
    formattedImageDescription() {
      let urlRegex = /(https?:\/\/[^\s]+)/g
      return this.imageDescription.replace(urlRegex, function(url) {
        return '<a href="' + url + '" target="_blank">' + url + '</a>'
      })
    }
  },
  watch: {
    skuImages() {
      this.selectedImageView = null
    },
    currentImageView: {
      immediate: true,
      handler(image) {
        if (image) this.imageDescription = image.caption
      }
    }
  },
  methods: {
    onClickControlSlider(command: string) {
       return command === 'prev'
        ? (this.currentImageListIndex -= 1)
        : (this.currentImageListIndex += 1)
    },
    onHoverSliderImage(id: number): SkuImage {
      this.selectedImageView = this.skuImagesItems.find(
        (skuImage: SkuImage) => skuImage.id === id
      )
      return this.selectedImageView
    },
    changeImageDescription(caption: string) {
      this.imageDescription = caption
    }
  }
})
